import { ResponsiveBlockSwitcher } from "@/shared/Components";
import type { NotesManagerProps } from "../model";
import { Desktop, Mobile } from "./components";

export const NotesManagerContent = ({
  notesManager,
  noteType,
  contactsPage,
}: NotesManagerProps) => {
  return (
    <ResponsiveBlockSwitcher
      desktop={
        <Desktop notesManager={notesManager} noteType={noteType} contactsPage={contactsPage} />
      }
      mobile={
        <Mobile contactsPage={contactsPage} notesManager={notesManager} noteType={noteType} />
      }
    />
  );
};
